import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Divider } from './Divider';
interface Faq {
  question: string;
  answer: string;
}
const faqs: Faq[] = [{
  question: '¿Necesito tener mucho tiempo libre para hacer este programa?',
  answer: 'No. El Método R.E.V.E.L.A. fue diseñado para personas con una vida ocupada. Solo necesitas entre 10 y 15 minutos al día. Puedes hacerlo por la mañana antes de comenzar tu día, en tu hora de almuerzo o antes de dormir. Lo importante no es cuándo lo haces — sino que lo haces.'
}, {
  question: '¿Funciona aunque lleve poco tiempo en la fe o me sienta lejos de Dios?',
  answer: 'Sí. Este programa no requiere que tengas un nivel avanzado de conocimiento bíblico ni una fe perfecta. Está diseñado precisamente para acompañarte en el proceso de acercarte a Dios — sin importar desde dónde estás comenzando. Lo único que necesitas es el deseo de dar el primer paso.'
}, {
  question: '¿Es compatible con mi iglesia o denominación cristiana?',
  answer: 'Sí. El Método R.E.V.E.L.A. está fundamentado en principios bíblicos universales que son compatibles con cualquier expresión de la fe cristiana. No reemplaza tu iglesia, tu pastor ni tus devocionales. Los complementa.'
}, {
  question: '¿Cómo recibo el programa después de comprarlo?',
  answer: 'Al completar tu compra recibirás acceso inmediato al Método R.E.V.E.L.A. y los 3 obsequios exclusivos. Todo llega directamente a tu correo electrónico en cuestión de minutos.'
}, {
  question: '¿Qué pasa si empiezo y siento que no es para mí?',
  answer: 'No hay ningún riesgo. El programa tiene una garantía de 7 días. Si en ese tiempo sientes que no es lo que esperabas, te devolvemos el 100% de tu inversión sin preguntas y sin complicaciones. La decisión de quedarte siempre será tuya.'
}, {
  question: '¿Puedo hacer el programa más de una vez?',
  answer: 'Absolutamente. Una vez que tienes acceso al programa, es tuyo para siempre. Muchas personas eligen repetirlo en diferentes etapas de su vida porque cada vez que lo hacen lo experimentan desde un lugar diferente.'
}, {
  question: '¿Por qué solo cuesta $17 dólares si incluye tanto?',
  answer: 'Porque creemos que el acceso a herramientas que fortalecen tu fe no debería estar limitado por el precio. Queremos que la mayor cantidad de creyentes posible pueda vivir en la paz y la abundancia que Dios ya prometió para sus vidas. El precio es accesible por decisión — no porque el valor sea pequeño.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-[#0A1535] py-20 px-6" style={{
    backgroundColor: "#5B401F",
    backgroundImage: "none"
  }} data-id="element-76" data-mp="3009ycbbr2y04">
      <div className="max-w-3xl mx-auto" data-id="element-77" data-mp="34v73h75wsn7q">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-white mb-4" data-id="element-78" data-mp="tagayvtcz942">
          Preguntas Frecuentes
        </motion.h2>

        <Divider data-id="element-79" data-mp="fbqdvg6jh9fp" />

        <div className="space-y-4 mb-12" data-id="element-80" data-mp="fc9qchdf75mc">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-[#0B1A3A] border border-[#E0B756]/20 rounded-lg overflow-hidden" style={{
            backgroundColor: "#E0B756",
            backgroundImage: "none"
          }} data-id="element-81" data-mp="17zcjetzbuo57" data-mpi={index}>
                <button onClick={() => toggle(index)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756]" style={{
              backgroundColor: "#E0B756",
              backgroundImage: "none"
            }} data-id="element-82" data-mp="1vpgnt3kcarx9">
                  <span className="text-lg font-semibold text-white" data-id="element-83" data-mp="1fj3p4bxs7kvu">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-[#E0B756] flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} style={{
                backgroundColor: "#F7F2E7",
                backgroundImage: "none"
              }} data-id="element-84" data-mp="11k41n7m09c19" />
                </button>

                <AnimatePresence initial={false} data-id="element-85" data-mp="1y6yyljmd2cj5">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-86" data-mp="1kgvf30ev8wxe">
                      <p className="px-6 pb-5 text-gray-300 leading-relaxed" style={{
                  color: "#F7F2E7"
                }} data-id="element-87" data-mp="2d3g968mq7n4n">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-88" data-mp="2n750gb5106ro">
          <motion.a href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gradient-to-r from-[#C9A24B] to-[#E0B756] text-[#0A1535] font-bold text-lg px-10 py-5 rounded-full shadow-lg hover:shadow-2xl transition-shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#E0B756] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A1535]" style={{
          color: "#FFFFFF"
        }} data-id="element-89" data-mp="3115qmghwwlgf">
            QUIERO COMENZAR MIS 30 DÍAS CON DIOS — $17 USD
          </motion.a>
        </div>
      </div>
    </section>;
}